import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import moment from 'moment-timezone';

    function QualityGridsFormatter(params, observableOptions) {
        var self = this;

        self.observableOptions = observableOptions;
        self.options = observableOptions();

        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();

        self.isHeader = params && params.type == "Header";
        self.isTitle = params && params.type == "Title";

        self.isEndpointQuality = self.options.isEndpoint;

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function combineSourceDestination(source, destination) {
        return '<span title="' + source + " -> " + destination + '">' + source + "&nbsp;&nbsp;<span class='flaticon-right11 iconarrow'></span>&nbsp;&nbsp;" + destination + '</span>';
    }

    function splitProtocol(txt) {
        var index = txt.indexOf("->");
        var res = txt.split("->");
        return (index <= -1) ? txt : '<span title="' + res[0] + " -> " + res[1] + '">' + res[0] + "&nbsp;&nbsp;<span class='flaticon-right11 iconarrow'></span>&nbsp;&nbsp;" + res[1] + '</span>';
    }

    function GetRTDataElement(source, numeric) {
        var result = null;
        var temp = null;

        if (source && (source.length > 0) && source[0].text) {
            temp = source[0].text;
        }
        if (numeric) {
            if (temp && $.isNumeric(temp)) {
                result = parseFloat(temp).toFixed(0);

                if (result === -1) {
                    result = null;
                }
            }
            else {
                result = null;
            }
        }
        else {
            result = temp;
        }
        return result;
    }

    function appendUnit(id, val) {
        if ((val == null) || (val == "")) {
            return "";
        }
        switch (id) {
            case 1: return val + ' fps';
            case 2: return val + ' kbps';
            case 3: return val + '%';
            case 4: return val + ' ms';
            default: return val;
        }
    }

    function convertToKbps(val, dontappendunit) {
        var maxvalue = (val != null) ? val : "";

        if (maxvalue <= 0) {
            return maxvalue;
        }
        var maxValueStr = Math.round(maxvalue / 1000).toString();

        return dontappendunit ? maxValueStr : appendUnit(2, maxValueStr);
    }

    function getQualityMetricMarkupForDetails(id, qualityIndicator, qualityValue) {
        var qualityClassNameMap = {
            '3': 'valRed',
            '2': 'valYellow'
        };
        var className = qualityClassNameMap[qualityIndicator] || '';
        return '<div title="' + appendUnit(id, qualityValue) + '" class="' + className + '">' + appendUnit(id, qualityValue) + '</div>';
    }

    function getQualityIndicatorVal(val, bands) {
        var maxvalue = (val != null) ? val : 0;
        var ind = 0;

        for (var i = 0; i < bands.length; i++) {
            var band = bands[i];
            if ((maxvalue >= band.min) && (maxvalue <= band.max)) {
                ind = band.ind;
                break;
            }
        }
        return ind;
    }

    function ComposeData(formatterCommon, gridFormatterCommon, sourcelist, options, isHeader, isTitle, initFlag) {
        var jitterColorBands = formatterCommon.jitterColorBands;
        var packetLossColorBands = formatterCommon.packetLossColorBands;

        var obj = {};
        var headers = [];
        var rowProperties = [];
        var vmrsource = sourcelist[options.callId];

        if (vmrsource && (vmrsource.length > 0)) {
            obj = vmrsource[vmrsource.length - 1];
        }

        var isVMR = _.has(obj, 'vmrdetail');
        var isCallControl = _.has(obj, 'ccsystemdetail');
        var isEndpoint = _.has(obj, 'endpointsystemdetail');

        var list = [];
        var finalList = [];

        if (isHeader) {
            if (!obj) {
                return null;
            }
            if ($.isEmptyObject(obj)) {
                return {
                    rows: []
                };
            }
            headers = ['Participant', 'Address', 'Call Type', 'Protocol', 'Call Rate', 'Presentation', 'Start Time'];

            if (obj.starttime) {
                obj.starttime = gridFormatterCommon.getTimeString(obj.starttime);
            }
            if (isVMR) {
                headers = ['Participant Name', 'Participant Alias', 'Call Type', 'Protocol', 'Call Rate', 'Presentation', 'Start Time'];
                list.push({ name: obj.name, dialstring: obj.remoteaddr, calltype: obj.calltype, protocol: obj.protocol, bitrate: obj.bitrate, presentation: obj.presentation, starttime: obj.starttime });
            } else if (isCallControl) {
                headers = ['<span title="Source -> Target">Source&nbsp;&nbsp;<span class="flaticon-right11 iconarrow"></span>&nbsp;&nbsp;Target</span>', 'Protocol', 'Call Rate', 'Presentation', 'Start Time'];
                list.push({ sourceAlias: obj.sourceAlias, destinationAlias: obj.destinationAlias, calltype: obj.calltype, protocol: obj.protocol, bitrate: obj.bitrate, presentation: obj.presentation, starttime: obj.starttime });
            } else if (isEndpoint) {
                list.push({ name: obj.name, dialstring: obj.remoteaddr, calltype: obj.calltype, protocol: obj.protocol, bitrate: obj.bitrate, presentation: obj.presentation, starttime: obj.starttime });
            }
            var sortableProperties = ['name', 'dialstring', 'calltype', 'protocol', 'bitrate', 'presentation', 'starttime'];
            var sortedList = gridFormatterCommon.sortList(list, sortableProperties, options);
            var pagedList = gridFormatterCommon.pageList(sortedList, options);
            var colWidth;

            pagedList.forEach(function(obj) {
                var remoteAddress = obj.dialstring;
                if (isVMR) {
                    colWidth = ['16%', '16%', '14%', '14%', '12%', '14%', '13%'];
                    rowProperties = ['name', 'dialstring', 'calltype', 'protocol', 'bitrate', 'presentation', 'starttime'];
                    finalList.push({ name: formatterCommon.getSpanTitle(obj.name), dialstring: formatterCommon.getSpanTitle(remoteAddress), calltype: obj.calltype, protocol: obj.protocol, bitrate: obj.bitrate ? obj.bitrate + " kbps" : "", presentation: obj.presentation, starttime: obj.starttime });
                } else if (isCallControl) {
                    colWidth = ['36%', '16%', '16%', '16%', '15%'];
                    rowProperties = ['name', 'protocol', 'bitrate', 'presentation', 'starttime'];
                    finalList.push({ name: combineSourceDestination(obj.sourceAlias, obj.destinationAlias), protocol: splitProtocol(obj.protocol), bitrate: obj.bitrate ? obj.bitrate + " kbps" : "", presentation: obj.presentation, starttime: obj.starttime });
                } else if (isEndpoint) {
                    colWidth = ['16%', '16%', '14%', '14%', '12%', '14%', '13%'];
                    rowProperties = ['name', 'dialstring', 'calltype', 'protocol', 'bitrate', 'presentation', 'starttime'];
                    finalList.push({ name: formatterCommon.getSpanTitle(obj.name), dialstring: formatterCommon.getSpanTitle(remoteAddress), calltype: obj.calltype, protocol: obj.protocol, bitrate: obj.bitrate ? obj.bitrate + " kbps" : "", presentation: obj.presentation, starttime: obj.starttime });
                }
            });
            return {
                rows: finalList,
                rowProperties: rowProperties,
                widths: colWidth,
                headers: headers
            };
        }
        else if (isTitle) {
            if (!obj) {
                return { message: "The call has ended" };
            }
            if (isVMR) {
                return { title: "VMRs > Call Details (" + GetRTDataElement(obj.vmrdetail.name) + ")"};
            }
            if (isCallControl) {
                return { title: "Active Calls > Call Details (" + obj.ccsystemdetail.name + ")" };
            }
            if (isEndpoint) {
                return { title: "Endpoints > Call Details (" + obj.endpointsystemdetail.name + ")" };
            }
        }
        else {
            if (!obj) {
                return null;
            }
            var headerGroups = ['', 'Audio', 'Audio', 'Video', 'Video', 'Presentation', 'Presentation'];
            headers = ['Parameters', 'Transmit', 'Receive', 'Transmit', 'Receive', 'Transmit', 'Receive'];

            if (!isCallControl) {
                list.push({ parameters: 'Codec', audioTransmit: obj.txAudioCodec, audioReceive: obj.rxAudioCodec, videoTransmit: obj.txVideoCodec, videoReceive: obj.rxVideoCodec, presentationTransmit: obj.txPresCodec, presentationReceive: obj.rxPresCodec });
                list.push({ parameters: 'Resolution', audioTransmit: obj.txAudioResolution, audioReceive: obj.rxAudioResolution, videoTransmit: obj.txVideoResolution, videoReceive: obj.rxVideoResolution, presentationTransmit: obj.txPresResolution, presentationReceive: obj.rxPresResolution });
                list.push({ parameters: 'Frame rate (fps)', audioTransmit: appendUnit(1, obj.txAudioFramerate), audioReceive: appendUnit(1, obj.rxAudioFramerate), videoTransmit: appendUnit(1, obj.txVideoFramerate), videoReceive: appendUnit(1, obj.rxVideoFramerate), presentationTransmit: appendUnit(1, obj.txPresFramerate), presentationReceive: appendUnit(1, obj.rxPresFramerate) });
            }
            list.push({ parameters: 'Channel rate (kbps)', audioTransmit: convertToKbps(obj.txAudioChannelrate), audioReceive: convertToKbps(obj.rxAudioChannelrate), videoTransmit: convertToKbps(obj.txVideoChannelrate), videoReceive: convertToKbps(obj.rxVideoChannelrate), presentationTransmit: convertToKbps(obj.txPresChannelrate), presentationReceive: convertToKbps(obj.rxPresChannelrate) });
            list.push({ parameters: 'Packet Loss (%)', audioTransmit: getQualityMetricMarkupForDetails(3, getQualityIndicatorVal(obj.txAudioPacketlossPerc, packetLossColorBands), obj.txAudioPacketlossPerc), audioReceive: getQualityMetricMarkupForDetails(3, getQualityIndicatorVal(obj.rxAudioPacketlossPerc, packetLossColorBands), obj.rxAudioPacketlossPerc), videoTransmit: getQualityMetricMarkupForDetails(3, getQualityIndicatorVal(obj.txVideoPacketlossPerc, packetLossColorBands), obj.txVideoPacketlossPerc), videoReceive: getQualityMetricMarkupForDetails(3, getQualityIndicatorVal(obj.rxVideoPacketlossPerc, packetLossColorBands), obj.rxVideoPacketlossPerc), presentationTransmit: getQualityMetricMarkupForDetails(3, getQualityIndicatorVal(obj.txPresPacketlossPerc, packetLossColorBands), obj.txPresPacketlossPerc), presentationReceive: getQualityMetricMarkupForDetails(3, getQualityIndicatorVal(obj.rxPresPacketlossPerc, packetLossColorBands), obj.rxPresPacketlossPerc) });
            list.push({ parameters: 'Jitter (ms)', audioTransmit: getQualityMetricMarkupForDetails(4, getQualityIndicatorVal(obj.txAudioJitter, jitterColorBands), obj.txAudioJitter), audioReceive: getQualityMetricMarkupForDetails(4, getQualityIndicatorVal(obj.rxAudioJitter, jitterColorBands), obj.rxAudioJitter), videoTransmit: getQualityMetricMarkupForDetails(4, getQualityIndicatorVal(obj.txVideoJitter, jitterColorBands), obj.txVideoJitter), videoReceive: getQualityMetricMarkupForDetails(4, getQualityIndicatorVal(obj.rxVideoJitter, jitterColorBands), obj.rxVideoJitter), presentationTransmit: getQualityMetricMarkupForDetails(4, getQualityIndicatorVal(obj.txPresJitter, jitterColorBands), obj.txPresJitter), presentationReceive: getQualityMetricMarkupForDetails(4, getQualityIndicatorVal(obj.rxPresJitter, jitterColorBands), obj.rxPresJitter) });

            return {
                maxCount: list.length,
                rows: list,
                rowProperties: ['parameters', 'audioTransmit', 'audioReceive', 'videoTransmit', 'videoReceive', 'presentationTransmit', 'presentationReceive'],
                headers: headers,
                headerGroups: headerGroups,
                widths: ['16%', '14%', '14%', '14%', '14%', '14%', '14%']
            };
        }
    }

    QualityGridsFormatter.prototype.RefreshData = function () {
        var self = this;
        self.observableFormattedData(ComposeData(self.formatterCommon, self.gridFormatterCommon, self.sourceList(), self.options, self.isHeader, self.isTitle));
    };

    QualityGridsFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    QualityGridsFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    QualityGridsFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        if (self.isEndpointQuality) {
            self.sourceList = dataRepository.endpointCallData;
        }
        else {
            self.sourceList = dataRepository.systemDetailParticipantData;
        }

        self.subscriptions.push(self.sourceList.subscribe(function() { self.DataUpdated(); }));
        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(self.sourceList())) {
            self.RefreshData();
        }
    };

    QualityGridsFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    QualityGridsFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default QualityGridsFormatter;
